import { ReactComponent as MoreRoundIcon } from "components/icons/moreRoundIcon.svg";
import "./MoreRoundButton.scss";

interface IMoreRoundButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const MoreRoundButton: React.FC<IMoreRoundButtonProps> = ({
  onClick
}) => {
  return (
    <button onClick={(event) => onClick(event)} className="MoreRoundButton" title="Show more actions">
      <MoreRoundIcon />
    </button>
  );
};
